import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import PricingPlanCard from './Pricing'

export default function index() {
  return (
    <div>
        <Header/>
        <PricingPlanCard/>
        <Footer/>
    </div>
  )
}
